<script>
	/** @type {'button' | 'submit' | 'reset'} */
	export let type = 'button';
	export let id = '';
	export let trackId = 'abc:free-button-1';
	export let href = '';
	/** @type {((event: Event) => void | Promise<void>) | (() => Promise<boolean | void>) | null} */
	export let onClick = null;
	export let disabled = false;
	export let disclaimer = '';
	export let text = '';
	export let containerClasses = '';
	export let btnClasses = '';
	export let textClasses = '';
	export let disclaimerClasses = '';
	/** @type {'red' | 'blue' | 'outlined'} */
	export let variant = 'red';
	/** When true, adds a shadow below the button */
	export let bottomShadow = false;

	const variantButtonClasses = {
		red: 'btn-primary-rebrand',
		blue: 'btn-primary-rebrand-blue',
		outlined: 'btn-outlined-rebrand',
	};

	const variantTextClasses = {
		red: 'relative z-10 mt-[0.2rem] text-center font-abcmouse-sans sm:text-[3rem] text-[2.2rem] font-extrabold text-white',
		blue: 'relative z-10 mt-[0.2rem] text-center font-abcmouse-sans sm:text-[3rem] text-[2.2rem] font-extrabold text-white',
		outlined:
			'relative z-10 mt-[0.2rem] text-center font-abcmouse-sans sm:text-[3rem] text-[2.2rem] font-extrabold text-deep-dive',
	};

	$: baseBtnClasses = variantButtonClasses[variant] || variantButtonClasses.red;
	$: baseTextClasses = variantTextClasses[variant] || variantTextClasses.red;
	$: shadowClass = bottomShadow ? 'shadow-[0_3px_0_0_#C7C7C9]' : '';

	/**
	 * Only preventDefault when we have a custom onClick (so type="submit" works when onClick is not set).
	 * @param {Event} e - The DOM click event.
	 */
	function handleClick(e) {
		if (onClick) {
			e.preventDefault();
			onClick(e);
		}
	}
</script>

<div
	class="flex w-full max-w-[32.7rem] flex-col items-center justify-center gap-[0.9rem] sm:max-w-[38.4rem] {containerClasses}"
>
	{#if href}
		<a
			{href}
			{id}
			data-track-id={trackId}
			class="{baseBtnClasses} {shadowClass} {btnClasses}"
			{...$$restProps}
		>
			<span class="{baseTextClasses} {textClasses}">{text}</span>
		</a>
	{:else}
		<button
			{id}
			{type}
			{disabled}
			on:click={handleClick}
			data-track-id={trackId}
			class="{baseBtnClasses} {shadowClass} {btnClasses}"
			{...$$restProps}
		>
			<span class="{baseTextClasses} {textClasses}">{text}</span>
		</button>
	{/if}

	{#if disclaimer}
		<p class="text-center text-[1.4rem] md:text-[2rem] {disclaimerClasses}">
			{disclaimer}
		</p>
	{/if}
</div>
